import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../../constants/calendarGrid'
import { DATE_WEEKDAY_SHORT_FORMAT } from '../../../../../constants/date'
import { formatCalendarGridDay } from '../../../../CalendarGrid'

export function getCalendarRelieveDaySubtitle({ day, dayLoad, locale }) {
  return [
    formatCalendarGridDay({
      dateFormat: DATE_WEEKDAY_SHORT_FORMAT,
      day,
      locale,
    }),
    dayLoad.summary,
  ].join(CALENDAR_GRID_LABEL_SEPARATOR)
}
